import { httpManager as http } from '@/common/js/HttpManager';
import { config } from 'CONFIG';
import { getCloudConfig } from '@/api/s3Config';

export const getProducts = () => {

    return new Promise(( resolve, reject ) => {

        http.get( `/shop/products/?type=cloud_storage_plan&client_id=${encodeURIComponent( config.clientId )}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const buyProduct = ( products ) => {

    return new Promise(( resolve, reject ) => {

        http.post( `/users/@me/shop-orders/`, products ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const deleteProduct = ( id, data ) => {

    return new Promise(( resolve, reject ) => {

        http.post( `/shop/subscriptions/${id}/cancellation/
        `, data ).then( res => {

            resolve( res );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

export const orderedProductInfo = async ( service = 'cloud_storage' ) => {

    try {

        let res = await http.get( `/shop/subscriptions/${service}/` );
        return res.data;

    } catch ( err ) {

        if ( err.response.data.error.code === 53258 ) {

            return null;

        } else {

            console.error( err );
            return err;

        }

    }

};

// 预览取消订阅操作的退款信息
export const previewRefundInfo = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/shop/subscriptions/${id}/cancellation/preview/` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

function calcStartOfNextCycle ( cycleStartedAt, cycleUnit, cycleInterval ) {

    switch ( cycleUnit ) {

        case 'day':
            return cycleStartedAt + cycleInterval * 86400000;
        case 'week':
            return cycleStartedAt + cycleInterval * 86400000 * 7;
        case 'month':
            return getSameDayOfNeighboringMonth( cycleStartedAt, cycleInterval ).getTime();
        case 'year':
            return getSameDayOfNeighboringMonth( cycleStartedAt, cycleInterval * 12 ).getTime();

    }

}

function getSameDayOfNeighboringMonth ( cycleStartedAt, cycleInterval ) {

    const date = new Date( cycleStartedAt );

    const nextDate = new Date(
        date.getFullYear(),
        date.getMonth() + cycleInterval,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );

    const rest = ( date.getMonth() + cycleInterval ) % 12;

    if ( rest < 0 ) {

        if ( rest + 12 === nextDate.getMonth()) {

            return nextDate;

        }

    } else {

        if ( rest === nextDate.getMonth()) {

            return nextDate;

        }

    }

    return new Date(
        date.getFullYear(),
        date.getMonth() + cycleInterval + 1,
        0,
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );

}

/**
 * 
 * @param {*} sub 
 * 
 * 免费套餐续费，需在剩余时间在一个周期之内
 */
export const freePlanRenewable = ( sub ) => {

    if ( !sub || sub.status === 'inactive' ) {

        return true;

    }
    if ( sub.plan.title === config.beta_plan_title ) {

        return false;

    }
    let { frequency, unit } = sub.plan.cycle.standard.interval;
    let oneCycleTime = calcStartOfNextCycle( new Date().getTime(), unit, frequency );
    let endingAt = sub.cycle.endingAt;
    return oneCycleTime > endingAt;

};

/**
 * 获取需要被筛选掉的活动套餐ID，没有则返回0
 * @param  onlyActivityPlan
 * true则筛选条件限制在当前用户订阅的套餐为活动套餐，false则限制在用户订阅的为非免费套餐
 * @param  currentSubscription  当前用户订阅的套餐信息
 */
export async function getActivityPlanId ( onlyActivityPlan = false, currentSubscription ) {

    if ( !currentSubscription ) {

        currentSubscription = await orderedProductInfo();

    }

    // 当前用户没有订阅信息时，currentSubscription = null
    // 此时不限制购买
    if ( !currentSubscription ) {

        return 0;

    }

    let planID = currentSubscription.plan.id;
    let planStatus = currentSubscription.status;
    let planPrice = Number( currentSubscription.plan.cycle.standard.salePrice );
    let now = new Date().getTime();
    let cloudConfig = await getCloudConfig();
    let activityPlanID = cloudConfig.activityPlanID;
    let activityEndTime = new Date( cloudConfig.activityEndTime ).getTime();
    let filter;

    if ( onlyActivityPlan ) {

        filter = planID === activityPlanID;

    } else {

        filter = planPrice !== 0;

    }
        
    if ( planStatus === 'active' && filter && now < activityEndTime ) {
        
        return activityPlanID;
        
    } else {

        return 0;

    }

}



// WEBPACK FOOTER //
// ./src/api/plan.js